
//declare var moment: any;
declare var timepicker: any;
namespace Nobox {
    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    export class CustomTimePickerEditor extends Serenity.Widget<any>
        implements Serenity.IStringValue, Serenity.IReadOnly {
        getEditValue(property: Serenity.PropertyItem, target): void {
            let pValue = this.element.find(".custom-timepicker-editor").val();
            target[property.name] = moment(pValue, 'hh:mm A').format('hh:mm A');
        }

        //private value: string;
        constructor(container: JQuery, options: ICustomTimePickerEditorOptions) {
            super(container, options);

            // hide the caption label for this editor if in a form. ugly hack
            if (this.options.hideLabel)
                this.element.closest('.field').find('.caption').hide();

            let elementFormat = '<input type="text" class="editor form-control custom-timepicker-editor">';
            if (options.fromFrmRs) {
                elementFormat = this.element.html();
            }


            this.element.html(elementFormat);

            if (this.options.containerClass) {
                this.element.addClass(this.options.containerClass);
            }

            if (this.options.enable) {
                this.element.find(".chkEnable").attr("checked", "checked");
            }
            else {
                this.element.find(".chkEnable").removeAttr("checked");
            }

            if (options.fromFrmRs) {
                this.element.first().timepicker({
                    defaultTime: false,
                    showMeridian: false,
                    showInputs: true,
                });
            } else {
                this.element.find(".custom-timepicker-editor").first().timepicker({
                    defaultTime: false,
                    showInputs: true,
                });
            }
        }

        get_value(): string {
            var value = this.element.find(".custom-timepicker-editor").first().val();
            if (this.options.fromFrmRs) {
                value = this.element.first().val();
            }
            if (value != null && value.length === 0) {
                return null;
            }
            return value;
        }

        get value(): string {
            return this.get_value();
        }

        set_value(value: string) {
            if (this.options.fromFrmRs) {
                if (value == null) {
                    this.element.val('');
                    this.element.first().timepicker('setTime', '12:00');
                    this.element.first().val('12:00');
                }
                else {
                    this.element.first().timepicker('setTime', value);
                    this.element.first().val(value);
                }
            } else {
                if (value == null) {
                    this.element.val('');
                    this.element.find(".custom-timepicker-editor").first().timepicker('setTime', '12.00 PM');
                    this.element.find(".custom-timepicker-editor").first().val('12.00 PM');
                }
                else {
                    this.element.find(".custom-timepicker-editor").first().timepicker('setTime', value);
                    this.element.find(".custom-timepicker-editor").first().val(value);
                }
            }
        }

        set value(v: string) {
            this.set_value(v);
        }

        get_readOnly(): boolean {
            return this.element.hasClass('readonly');
        }

        set_readOnly(value: boolean): void {

            if (value !== this.get_readOnly()) {
                if (value) {
                    this.element.find('.custom-timepicker-editor').addClass('readonly').attr('readonly', 'readonly');
                    this.element.find('.custom-timepicker-editor').attr('disabled', 'true');
                }
                else {
                    this.element.find('.custom-timepicker-editor').removeClass('readonly').removeAttr('readonly');
                    this.element.find('.custom-timepicker-editor').removeAttr('disabled');
                }
            }
        }
    }

    export interface ICustomTimePickerEditorOptions {
        hideLabel: boolean;
        containerClass: string;
        enable: boolean;
        fromFrmRs: boolean;
        // declare TimePicker options here
    }

}